/** Mora odgovarati `BillingItemKindIds` na backendu. */
export const BillingItemKindId = {
  Najamnina: "najamnina",
  PrekoracenjeKm: "prekoracenje_km",
  Kazna: "kazna",
  Steta: "steta",
  Gorivo: "gorivo",
  DodatnaUsluga: "dodatna_usluga",
  Ostalo: "ostalo",
} as const;

export type BillingItemKindIdType = typeof BillingItemKindId[keyof typeof BillingItemKindId];

